import { useEffect, useState } from "react";
import DropdownSmall from "../../../Shared Components/DropdownSmall";

function MobileBlockSlotFilters(props) {
  const { onClick, data, filters, setFilter, resetParam } = props;
  const [animateFilter, setAnimateFilter] = useState({
    transform: "translate(100%)",
  });

  useEffect(() => {
    if (props.isOpenFilter) {
      setAnimateFilter({
        transform: "translate(0%)",
      });
    } else {
      setAnimateFilter({
        transform: "translate(100%)",
      });
    }
  }, [props.isOpenFilter]);

  return (
    <div style={animateFilter} className="mobile-bydate-filters-container">
      <div
        onClick={() => {
          props.setIsOpenFilter(false);
        }}
        className="left-filter-section"
      ></div>
      <div className="right-filter-section">
        <div className="mt-3" onClick={onClick}>
          <button className="apply">Block Slot</button>
        </div>

        <div className="right-filter-sub-container pt-3 pb-3">
          <p className="title">Filter</p>

          <div>
            <div className="right-date-filter-container">
              <DropdownSmall
                data={data}
                label="Choose Date"
                htmlFor="date"
                type="text"
                width="auto"
                stateData={filters?.date}
                setStateData={(e) => {
                  delete filters.fromDate;
                  delete filters.tillDate;
                  setFilter({
                    ...filters,
                    date: e,
                  });
                }}
              />
            </div>
          </div>

          <div>
            <button className="reset" onClick={resetParam}>
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileBlockSlotFilters;
